<template>
  <div class="sfBtm">
    <div class="content">
      <div class="contentLeft" @click="toRegister()">
        <img src="./../../../assets/school/register.png" alt="" />
        <span>我要注册</span>
      </div>
      <div class="contentRight">
        <span @click="toApp()">前往APP</span>
        <span @click="showPopup = true">我要锁粉</span>
      </div>
    </div>
    <van-popup v-model="showPopup">
      <div class="sfBtmPopup">
        <img src="./../../../assets/school/shareSf.png" alt="" />
        <div class="sfBtmPopupConten">
          <div class="sfBtmPopupText">
            <p>1.输入手机号，验证并提交<span>（您当前在这一步)</span></p>
            <p>2.将已携带您会员信息的页面分享给更多人</p>
            <p>
              3.其他人在点击您的链接并输入非销巴会员手机号验证成功后，将自动成为您的会员，会员在销巴生活完成的每一笔有效订单都能给您创造收益
            </p>
          </div>
          <van-field
            v-model="bMobile"
            type="digit"
            :border="false"
            placeholder="请输入手机号"
          />
          <div class="sfBtmPopupCode">
            <van-field
              v-model="code"
              type="digit"
              :border="false"
              placeholder="请输入验证码"
            >
              <template #button>
                <span @click="getCode()" v-if="downcounttime == 0"
                  >获取验证码</span
                >
                <span @click="getCode()" v-else
                  >{{ downcounttime }}s后获取</span
                >
              </template>
            </van-field>
          </div>
          <div class="sfBtmPopupButton">
            <span @click="showPopup = false">取消</span>
            <span @click="sfBtmPopupConfim()">确定</span>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
export default {
  props: {
    mobile: {
      required: true,
    },
  },
  data() {
    return {
      showPopup: false,
      bMobile: "",
      code: "",
      downcounttime: 0,
      isiOS: false,
    };
  },
  mounted() {
    let ua = navigator.userAgent.toLowerCase();
    if (/iphone|ipad|ipod|macintosh/i.test(ua)) {
      this.isiOS = true;
    } else {
      this.isiOS = false;
    }
  },
  methods: {
    // 去注册
    toRegister() {
      this.$router.push({
        path: "/school/shareRegister",
        query: {
          aMobile: this.mobile,
        },
      });
    },
    // 打开App
    toApp() {
      if (this.isiOS) {
        window.location.href =
          "http://itunes.apple.com/cn/app/id1273703378?ls=1&mt=8";
      } else {
        this.$router.push("/school/load");
      }
    },
    // 关闭遮罩层
    closeMaskShow() {
      this.maskShow = false;
    },
    // 获取验证码
    getCode() {
      const _this = this;
      if (this.downcounttime == 0) {
        // 获取验证码
        this.$api
          .post("/pushmsg/index/sms/send-code", {
            mobile: this.bMobile,
            type: 48,
          })
          .then((res) => {
            this.downcounttime = 60;
            const timer = setInterval(() => {
              _this.downcounttime--;
              if (_this.downcounttime <= 0) {
                clearInterval(timer);
                _this.downcounttime = 0;
              }
            }, 1000);
          })
          .catch((err) => {
            let keys = Object.keys(err);
            let key = keys[0];
            let message = err.message || err[key][0];
            //this.$toast(message);
            if (message.slice(0, 10) == "timeout of") {
              this.$toast("网络不给力，请稍候重试");
            } else {
              this.$toast(message);
            }
          });
      } else {
        _this.$toast("验证码已发送，请注意查收");
      }
    },
    // 分享锁粉
    sfBtmPopupConfim() {
      this.$api
        .post("/school/index/share/register", {
          referrer_username: this.mobile, //推荐人手机号
          username: this.bMobile, //注册手机号
          code: this.code, //验证码
          type: 1,
        })
        .then((res) => {
          // 注册成功!生成新链接并自动跳转
          let oldHref = location.href;
          let oldHrefLength = oldHref.length;
          let mobileLastIndexOf = oldHref.lastIndexOf("mobile=") + 7;
          let shareCodeLastIndexOf = oldHref.lastIndexOf("&shareCode=");
          let substringMobile = "";
          if (oldHref.lastIndexOf("&shareCode") == -1) {
            // 不存在shareCode
            substringMobile = oldHref.substring(
              mobileLastIndexOf,
              oldHrefLength
            );
          } else {
            // 存在shareCode
            substringMobile = oldHref.substring(
              mobileLastIndexOf,
              shareCodeLastIndexOf
            );
          }
          let newHref = oldHref.replace(substringMobile, this.bMobile);
          // 跳转
          window.location.href = newHref;
        })
        .catch((err) => {
          this.flag = 0;
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          //this.$toast(message);
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else {
            this.$toast(message);
          }
        });
    },
  },
};
</script>
<style lang="less" scoped>
.sfBtm {
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 998;
  width: 100%;
  height: 70px;
  background: #ffffff;
  box-shadow: inset 0px 1px 0px 0px #f7f8fc;
  .content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 7px 16px 17px;
    height: 46px;
    .contentLeft {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      img {
        width: 24px;
        height: 24px;
      }
      span {
        font-size: 12px;
        font-weight: 500;
        color: #6e727a;
      }
    }
    .contentRight {
      margin-left: 16px;
      flex: 1;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 100%;
      span {
        flex: 1;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 15px;
        font-weight: 500;
        color: #ffffff;
      }
      span:first-child {
        background: linear-gradient(90deg, #ffc783 0%, #ff5700 100%);
        border-radius: 100px 0px 0px 100px;
      }
      span:last-child {
        background: linear-gradient(270deg, #86b4fc 0%, #4e7df7 100%);
        border-radius: 0px 100px 100px 0px;
      }
    }
  }
  .van-popup {
    background-color: rgba(255, 255, 255, 0);
    overflow: visible;
  }
  .sfBtmPopup {
    width: 300px;
    height: 418px;
    position: relative;
    background-color: #ffffff;
    border-radius: 16px;
    img {
      width: 300px;
      height: 237px;
      position: absolute;
      top: -37px;
    }
    .sfBtmPopupConten {
      position: absolute;
      top: 95px;
      padding: 0 24px 20px;
      display: flex;
      flex-direction: column;
      .sfBtmPopupText {
        margin-bottom: 16px;
        p {
          font-size: 13px;
          font-weight: 400;
          color: #404247;
          line-height: 18px;
          span {
            font-size: 12px;
            color: #9ca1ad;
          }
        }
      }
      .van-cell {
        padding: 0;
        background: #f7f8fc;
        border-radius: 24px;
        line-height: 21px;
        padding: 8px 16px;
      }
      .van-field__control {
        color: #c1c4d9;
      }
      .sfBtmPopupCode {
        margin-top: 16px;
        display: flex;
        justify-content: space-between;
        span {
          border-left: 2px solid #e4e7f5;
          height: 20px;
          font-size: 14px;
          font-weight: 500;
          color: #4e7df7;
          padding-left: 8px;
        }
      }
      .sfBtmPopupButton {
        margin-top: 24px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        span {
          width: 120px;
          height: 42px;
          border-radius: 21px;
          font-size: 15px;
          font-weight: 400;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        span:first-child {
          background: rgba(78, 125, 247, 0.1);
          color: #4e7df7;
        }
        span:last-child {
          background: linear-gradient(270deg, #86b4fc 0%, #4e7df7 100%);
          color: #ffffff;
        }
      }
    }
  }
}

.sfBtm ::-webkit-input-placeholder {
  color: #c1c4d9;
}
// .sfBtm ::v-deep .van-popup--center {
//   top: 47%;
// }
</style>
